import { Injectable } from '@angular/core';
import { NativeBiometric } from 'capacitor-native-biometric';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class BiometricAuthService {
  noShowBio = false;

  async isBiometricAvailable() {
    const result = NativeBiometric.isAvailable();
    return result;
  }

  async isBiometricStored() {
    const username = await NativeBiometric.getCredentials({
      server: `${environment.bio_url}`,
    })
      .then(() => true)
      .catch(() => false);
    return username;
  }

  async performBiometricVerification() {
    const result = await NativeBiometric.isAvailable().catch(() => null);
    let verified = false;

    if (!result.isAvailable) {
      return;
    }


    const credentials = await NativeBiometric.getCredentials({
      server: `${environment.bio_url}`,
    }).catch(() => null);

    if (credentials && credentials.username) {
      verified = await NativeBiometric.verifyIdentity({
        reason: 'Biometric Authentication',
        title: 'Please Authenticate',
      })
        .then(() => true)
        .catch(() => false);
    }
    if (!verified) {
      return;
    }
    return credentials;
  }

  async saveCredentials(email, password) {
    return NativeBiometric.setCredentials({
      username: email,
      password,
      server: `${environment.bio_url}`,
    });
  }

  deleteCredentials() {
    NativeBiometric.deleteCredentials({
      server: `${environment.bio_url}`,
    })
      .then(() => true)
      .catch(() => false);
  }
}
